<template>
  <div class="labels-sheet">
    <div class="item-cells">
      <div
        class="item-cell"
        v-for="(explanation, index) in newExp"
        :key="index"
        @click="track(explanation)"
      >
        <div class="item-cell-hd">
          <img :src="$$viewImage(explanation.image)" alt="" />
        </div>
        <div class="item-cell-bd">
          <p>{{ explanation.title }}</p>
          <p class="label">{{ explanation.fu_title }}</p>
        </div>
        <div class="item-cell-ft" v-if="explanation.link !== ''">
          <i class="iconfont icon-youjiantou"></i>
        </div>
        <a
          :href="explanation.link"
          v-if="explanation.link !== ''"
          class="link"
        ></a>
      </div>
    </div>

    <TextExplanation
      :level4CategoryId="product.level4CategoryId"
      :exp="yuerTextExplanation"
    ></TextExplanation>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import TextExplanation from '@/components/common/textExplanation'
export default {
  props: {
    params: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState(['product', 'mainConfig']),
    serveExplanation() {
      return this.mainConfig && this.mainConfig.serviceWarrantyDes
    },
    yuerTextExplanation() {
      return this.mainConfig && this.mainConfig.yuerTextExplanation
    },
    newExp() {
      // 不可退
      const refund = this.serveExplanation.filter(
        ele => ele.name === 'refund_supply'
      )[0]
      // 随时退
      const return_anytime = this.serveExplanation.filter(
        ele => ele.name === 'refund_anytime'
      )[0]
      // 过期退
      const return_overdue = this.serveExplanation.filter(
        ele => ele.name === 'refund_overdue'
      )[0]
      // 其他显示
      const other_exp = this.serveExplanation.filter(
        ele =>
          ele.name !== 'refund_supply' &&
          ele.name !== 'refund_anytime' &&
          ele.name !== 'refund_overdue'
      )
      let left_exp = []
      // if (this.product.refund_supply === 0 && refund) { // 0: 不可退, 1:可退
      //     left_exp.push(refund)
      // } else {
      //     if (this.product.refund_overdue === 1 && return_overdue) {
      //         left_exp.push(return_overdue)
      //     }
      //     if (this.product.refund_anytime === 1 && return_anytime) {
      //         left_exp.push(return_anytime)
      //     }
      // }

      if (
        this.product.isAnyTimeRefund === 0 &&
        this.product.isExpiredRefund === 0
      ) {
        left_exp.push(refund)
      } else {
        if (this.product.isAnyTimeRefund === 1) {
          left_exp.push(return_anytime)
        }
        if (this.product.isExpiredRefund === 1) {
          left_exp.push(return_overdue)
        }
      }
      // if (this.product.isSchedule * 1 === 1) {
      //     lb.push({ title: '需预约', isGood: true })
      // } else {
      //     lb.push({ title: '过期退', isGood: true })
      // }
      // return lb;
      left_exp = left_exp.concat(other_exp)
      return left_exp
    }
  },
  methods: {
    track(explanation) {
      if (explanation.link !== '') {
        this.$$tracker('100101', '20000', 21015)
      }
    },
    couldShow(item) {
      if (item.name === 'refund_anytime') {
        return item.isGood === 1 && this.params.product.refund_anytime === 1
      } else if (item.name === 'refund_overdue') {
        return item.isGood === 1 && this.params.product.refund_overdue === 1
      } else if (item.name === 'refund_supply') {
        return item.isGood === 1 && this.params.product.refund_supply === 1
      } else {
        return item.isGood === 1
      }
    }
  },
  components: {
    TextExplanation
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';

.labels-sheet {
  padding-top: rem(6px);
  .item-cell-hd {
    width: rem(30px);
    height: rem(30px);
    padding: 0;
    overflow: hidden;
    margin-right: rem(20px);
    margin-top: rem(2px);
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
    .unuse {
      color: #999;
    }
  }
  .item-cell {
    align-items: flex-start;
    padding: rem(18px);
  }
  .link {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
  }
  .icon-youjiantou {
    font-size: rem(40px);
  }
  .item-cell-bd {
    p {
      line-height: rem(34px);
      font-size: rem(28px);
      color: #121212;
      font-weight: bold;
    }
    .label {
      font-weight: normal;
      padding-top: rem(8px);
      line-height: rem(36px);
      color: #666;
      font-size: rem(24px);
      margin-top: rem(10px);
    }
  }
}
</style>
<style lang="scss">
@import '../../assets/css/mixin';
.explanation-rich-text {
  padding: rem(24px);
  font-size: rem(26px);
  color: #262626;
  h2 {
    font-size: rem(32px);
  }
}
</style>
